// Session token storage + Bearer attachment for the dashboard.
//
// We use a Bearer token (not a cookie) deliberately: the dashboard is served from
// dutyai.in while the API is api.dutyai.in — a cross-subdomain pair where SameSite
// cookies are painful. The backend's get_current_user already accepts
// `Authorization: Bearer <token>` (backend/auth.py), and the candidate interview flow
// (lib/interviewApi.js) already uses the same pattern, so this is consistent.

const KEY = 'duty_session_token';

export const getToken = () => {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const setToken = (t) => {
  try {
    if (t) localStorage.setItem(KEY, t);
    else localStorage.removeItem(KEY);
  } catch {
    /* storage disabled — session simply won't persist across reloads */
  }
};

export const clearToken = () => setToken(null);

// Install a request interceptor on an axios instance so every call carries the
// session token when present. Safe to call on multiple instances.
export const attachBearer = (client) => {
  client.interceptors.request.use((config) => {
    const t = getToken();
    if (t) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
  });
  return client;
};
